module.exports = __webpack_public_path__ + "img/icon-96x96.5786dfa1.png";